/** @format */

import React, { Component } from "react";
import {
	Button,
	ModalBody,
	Modal,
	Row,
	Col,
	Form,
	Input,
	InputGroupAddon,
	InputGroup,
	Badge,
} from "reactstrap";
import Icon from "./Icon";
import Select from "react-select";
import _ from "underscore";
import SwiperGallery from "./SwiperGallery";
import {
	setCookie,
	getCookie,
	eraseCookie,
	setLocalStorage,
	getLocalStorage,
	getUrlParam,
	setCookieOneHr,
} from "../global/browserFunctions";
import { cartUrl } from "../global/url";
import { showNotification } from "../global/notification";
import jquery from "jquery";
import Loader from "../components/Loader";

class ModalQuickView extends Component {
	constructor(props) {
		super(props);
		//console.log('propsaaa',props)
		this.ref = React.createRef(null);
		this.state = {
			product: props.product,
			quantity: 1,
			itemid: "",
			loading: false,
			name:
				(props.product &&
					props.product.item_itemid_text &&
					props.product.item_itemid_text.value) ||
				"",
			price:
				(props.product &&
					props.product.item_baseprice &&
					props.product.item_baseprice.value) ||
				"",
			yourPrice:
				(props.product &&
					props.product.item_baseprice &&
					props.product.item_baseprice.value) ||
				"",
			img: [],
			description:
				(props.product &&
					props.product.item_storedescription &&
					props.product.item_storedescription.value) ||
				"",
			url:
				(props.product &&
					props.product.item_detailspage_url &&
					props.product.item_detailspage_url.value) ||
				"",
			currentIndex: 0,
			bicycleSize: "",
			bicycleColor: "",
			bicycleSpeed: "",
			accColor: "",
			accSize: "",
			item_custitembicyclesize: [],
			item_custitembicyclecolor: [],
			item_custitembicyclespeed: [],
			item_custitembicycleaccessorycolor: [],
			item_custitembicycleaccessorysize: [],
			stockInfo: [],
			addToCartEnabled: false,
			isOutofStock: true,
		};

		this.customSelectStyles = {
			control: (provided, state) => ({
				...provided,
				border: "1px solid #ced4da",
				borderRadius: "0",
				width: 200,
				cursor: "pointer",
			}),
			indicatorSeparator: (provided, state) => ({
				display: "none",
			}),
			menu: (provided, state) => ({
				...provided,
				color: "#343a40",
				border: "0 solid #fff",
				borderRadius: 0,
				boxShadow: "0 0 1.2rem rgba(0, 0, 0, .15)",
			}),
			option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
				...provided,
				backgroundColor: isDisabled
					? null
					: isSelected
						? "#bcac76"
						: isFocused
							? "#eee"
							: null,
				":active": {
					...provided[":active"],
					backgroundColor: "#e2dabc",
				},
				cursor: "pointer",
			}),
		};

		this.toggle = this.toggle.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleSelect = this.handleSelect.bind(this);
	}

	shouldComponentUpdate(nextProps, nextState) {
		//The modal is used in overall category page, so to handle the item change we use this method

		if (this.state.product != nextProps.product) {
			this.setState({ product: nextProps.product }, function () {
				if (this.state.product) {
					this.setState({ url: this.state.product.item_detailspage_url.value });
					this.setState({
						img: [{ img: this.state.product.item_image_thumbnail_url.value }],
					});
					this.setState({
						description: this.state.product.item_storedescription.value,
					});
					this.setState({ name: this.state.product.item_itemid_text.value });
					this.setState(
						{ price: this.state.product.item_baseprice.value },
						function () {
							this.setAllDetails();
						}
					);
					///this.forceUpdate();
				}
			});
			return true;
		}
		return true;
	}

	componentDidMount() {
		this.setAllDetails();
	}

	setAllDetails() {
		var self = this;
		var options = {
			bicycleColor: "item_custitembicyclecolor",
			bicycleSize: "item_custitembicyclesize",
			bicycleSpeed: "item_custitembicyclespeed",
			accSize: "item_custitembicycleaccessorysize",
			accColor: "item_custitembicycleaccessorycolor",
		}; //Matrix options which are predefined by client

		var keys = _.keys(options);
		var value = _.values(options);
		var item = this.state.product;
		for (var i in value) {
			var arr = [];
			// var matrixOption = item[value[i]] || {value:""};
			// if (matrixOption.value != "") {
			// 	var values = matrixOption.value.split(",");
			// 	var label = matrixOption.text.split(",");
			// 	for (var j in values) {
			// 		var obj = {};
			// 		obj.label = label[j];
			// 		obj.value = values[j];
			// 		obj.name = value[i];
			// 		obj.id = keys[i];
			// 		arr.push(obj);
			// 	}
			// }
			var childItems = item.child_items || {};
			for (var j in childItems) {
				//Loop to create matrix option select box from child items
				var obj = childItems[j][value[i]] || { value: "" };
				if (obj.value != "") {
					obj.label = obj.text;
					obj.id = keys[i];
					obj.name = value[i];
					arr.push(obj);
				}
			} //Set obj data {lable:"", id:"", name:""}

			var filteredArr = arr.reduce((acc, current) => {
				//To remove duplicate matrix option if exists
				const x = acc.find((item) => item.value === current.value);
				if (!x) {
					return acc.concat([current]);
				} else {
					return acc;
				}
			}, []);

			filteredArr = _.sortBy(filteredArr, "label"); //To sort the options alphabetically

			this.setState({ [value[i]]: filteredArr }, function () {
				self.setItemDetails();
			});
			this.setState(
				{ [keys[i]]: filteredArr.length > 0 ? filteredArr[0] : "" },
				function () {
					self.setItemDetails();
				}
			);
		}
	}

	handleSelect(e) {
		var self = this;
		this.setState({ [e.id]: e }, function () {
			self.setItemDetails();
		});
	}

	setItemDetails() {
		this.setState({ addToCartEnabled: false });
		this.setState({ isOutofStock: true });

		var pricelevel = getCookie("pricelevel") || "1";
		var basePriceLevel = "1";
		var optionsSelected = {
			item_custitembicyclesize:
				(this.state.bicycleSize && this.state.bicycleSize.value) || "",
			item_custitembicyclecolor:
				(this.state.bicycleColor && this.state.bicycleColor.value) || "",
			item_custitembicyclespeed:
				(this.state.bicycleSpeed && this.state.bicycleSpeed.value) || "",
			item_custitembicycleaccessorycolor:
				(this.state.accColor && this.state.accColor.value) || "",
			item_custitembicycleaccessorysize:
				(this.state.accSize && this.state.accSize.value) || "",
		}; //Get selected item options

		var childItems = this.state.product
			? this.state.product["child_items"]
			: {};
		//If all selected option match with an item, then its details are set in page
		for (var key in childItems) {
			var biSize = childItems[key]["item_custitembicyclesize"].value;
			var biColor = childItems[key]["item_custitembicyclecolor"].value;
			var biSpeed = childItems[key]["item_custitembicyclespeed"].value;
			var accSize = childItems[key]["item_custitembicycleaccessorysize"].value;
			var accColor =
				childItems[key]["item_custitembicycleaccessorycolor"].value;

			if (
				biSize == optionsSelected["item_custitembicyclesize"] &&
				biColor == optionsSelected["item_custitembicyclecolor"] &&
				biSpeed == optionsSelected["item_custitembicyclespeed"] &&
				accSize == optionsSelected["item_custitembicycleaccessorysize"] &&
				accColor == optionsSelected["item_custitembicycleaccessorycolor"]
			) {
				var price =
					(childItems[key].price_levels[basePriceLevel] &&
						childItems[key].price_levels[basePriceLevel]
							.item___pricing_unitprice &&
						childItems[key].price_levels[basePriceLevel]
							.item___pricing_unitprice.value) ||
					childItems[key].item_baseprice.value; //Set baseprice from child
				var yourPrice =
					(childItems[key].price_levels[pricelevel] &&
						childItems[key].price_levels[pricelevel].item___pricing_unitprice &&
						childItems[key].price_levels[pricelevel].item___pricing_unitprice
							.value) ||
					price; //Set customer level price from child
				this.setState({ name: childItems[key].item_itemid.value });
				this.setState({ price: price });
				//this.setState({img: childItems[key].item_image_thumbnail_url.value});
				this.setState({
					img: [{ img: childItems[key].item_image_thumbnail_url.value }],
				});
				this.setState({
					description: childItems[key].item_storedescription.value,
				});
				this.setState({ yourPrice: yourPrice });
				this.setState({ itemid: childItems[key].item_internalid.value });

				var stockInfo = [];
				var locations = childItems[key].stock_availability;

				for (var i in locations) {
					if (
						locations[i].item_inventorylocation &&
						locations[i].item_inventorylocation.text
					) {
						var obj = {};
						obj.name = locations[i].item_inventorylocation.text;
						obj.text = locations[i].item_locationquantityavailable_text.value;
						if (obj.text.indexOf('>') || obj.text.indexOf('<')) {
							obj.text = obj.text.replace(/</, '< ');
							obj.text = obj.text.replace(/>/, '> ')
						}
						if (obj.text != "OUT OF STOCK") {
							this.setState({ addToCartEnabled: true });
							this.setState({ isOutofStock: false });
						}
						stockInfo.push(obj);
					}
				}

				this.setState({ stockInfo: stockInfo });
			}
		}
	}

	toggle() {
		this.props.toggle();
	}

	handleChange(e) {
		var target = e.target;
		var name = target.name;
		var value = target.value;
		this.setState({ [name]: value });
	}

	handleSubmit(event) {
		var self = this;
		this.setState({ addToCartEnabled: false });
		this.setState({ loading: true });
		var query = "&method=add&customer=";
		var customer = getCookie("customid");
		query += customer;
		query += "&img=" + encodeURIComponent(this.state.img[0].img);
		var matrixOption = {
			item_custitembicycleaccessorycolor: this.state.accColor,
			item_custitembicycleaccessorysize: this.state.accSize,
			item_custitembicyclecolor: this.state.bicycleColor,
			item_custitembicyclesize: this.state.bicycleSize,
			item_custitembicyclespeed: this.state.bicycleSpeed,
		};

		matrixOption = JSON.stringify(matrixOption);
		query += "&matrixoption=" + encodeURIComponent(matrixOption);
		query += "&link=" + encodeURIComponent(this.state.url);
		query += "&itemId=" + encodeURIComponent(this.state.itemid);
		query += "&qty=" + encodeURIComponent(this.state.quantity);
		event.preventDefault();

		jquery
			.ajax({
				url: cartUrl + query,
				Cache: false,
				dataType: "jsonp",
			})
			.done(function (data) {
				self.setState({ loading: false });
				try {
					data = JSON.parse(decodeURIComponent(data));
					if (data.summary && data.summary.status == "SUCCESS") {
						var count = parseInt(getCookie("cartCount") || 0);
						count = count + parseInt(self.state.quantity);
						self.props.updateCartCount(count);
						self.setState({ quantity: 1 });
						showNotification("Added to cart", "success", " ");
						setTimeout(() => {
							window.location.reload();
						}, 2000);
					}
				} catch (error) {
					console.log("err@fectchcart", error);
				}
			})
			.fail(function () {
				self.setState({ loading: false });
				showNotification(
					"Sorry",
					"danger",
					"An unknown error occurred. Please try again later"
				);
			});
	}

	render() {
		return (
			<React.Fragment>
				<Loader loading={this.state.loading} />
				<Modal
					isOpen={this.props.isOpen}
					toggle={this.toggle}
					size='xl'
					modalClassName='quickview'
				>
					{/* CLOSE BUTTON */}
					<button
						className='close close-absolute close-rotate'
						onClick={this.toggle}
						type='button'
					>
						<Icon
							className='w-3rem h-3rem svg-icon-light align-middle'
							icon='close-1'
						/>
					</button>
					{/* END CLOSE BUTTON */}
					<ModalBody className='quickview-body'>
						<Row>
							<Col lg='6'>
								<SwiperGallery data={this.state.img} isPLP={true} />
								{/* <div className='detail-carousel'>

									<ReactIdSwiper>
										<img
											className='img-fluid'
											src={this.state.img}
										/>
									</ReactIdSwiper>
								</div> */}

								<table className='table text-sm'>
									{this.state.stockInfo.map((infoBlock, index) => (
										<tbody key={index}>
											<tr>
												<th className='font-weight-normal border-0'>
													{infoBlock.name}
												</th>
												<td className='text-muted border-0'>
													{infoBlock.text.replace(/,/g, ", ")}
												</td>
											</tr>
										</tbody>
									))}
								</table>
							</Col>

							<Col lg='6' className='p-lg-5'>
								<h2 className='mb-4 mt-4 mt-lg-1'>
									<a href={this.state.url}>{this.state.name}</a>
								</h2>
								{this.state.isOutofStock && (
									<div className='mb-3'>
										<Badge color='danger-light'>Out of stock</Badge>
									</div>
								)}
								{!this.state.isOutofStock && (
									<div className='mb-3'>
										<Badge color='success-light'>In Stock</Badge>
									</div>
								)}
								<div className='d-flex flex-column flex-sm-row align-items-sm-center justify-content-sm-between mb-4'>
									{/* PRODUCT PRICES */}
									<ul className='list-inline mb-2 mb-sm-0'>
										{this.state.price && (
											<li className='h4 font-weight-light mb-0'>
												<span className='text-dark text-md'>
													Your Price: ${this.state.yourPrice}
												</span>
											</li>
										)}
										{this.state.price && (
											<li className='list-inline-item h4 font-weight-light mb-0'>
												<span className='text-gray-500 text-lg'>
													MSRP: ${this.state.price}
												</span>
											</li>
										)}
									</ul>
									{/* END PRODUCT PRICES */}
								</div>

								{/* PRODUCT DESRIPTION */}
								<p className='mb-4 text-muted'>{this.state.description}</p>
								{/* END PRODUCT DESCRIPTION */}

								<Form onSubmit={this.handleSubmit}>
									<Row>
										{this.state.item_custitembicyclesize.length > 0 ? (
											<Col sm='6' lg='12' className='detail-option mb-4'>
												<h6 className='detail-option-heading'>
													Size <span>(required)</span>
												</h6>
												<Select
													name='item_custitembicyclesize'
													id='item_custitembicyclesize'
													options={this.state.item_custitembicyclesize}
													autosize={true}
													defaultValue={this.state.item_custitembicyclesize[0]}
													className='react-select-container'
													classNamePrefix='react-select'
													styles={this.customSelectStyles}
													isSearchable={false}
													onChange={(e) => this.handleSelect(e)}
													value={this.state.bicycleSize}
												/>
											</Col>
										) : (
											""
										)}
										{this.state.item_custitembicyclecolor.length > 0 ? (
											<Col sm='6' lg='12' className='detail-option mb-4'>
												<h6 className='detail-option-heading'>
													Color <span>(required)</span>
												</h6>
												<Select
													name='item_custitembicyclecolor'
													id='item_custitembicyclecolor'
													options={this.state.item_custitembicyclecolor}
													autosize={true}
													defaultValue={this.state.item_custitembicyclecolor[0]}
													className='react-select-container'
													classNamePrefix='react-select'
													styles={this.customSelectStyles}
													isSearchable={false}
													onChange={(e) => this.handleSelect(e)}
													value={this.state.bicycleColor}
												/>
											</Col>
										) : (
											""
										)}
										{this.state.item_custitembicyclespeed.length > 0 ? (
											<Col sm='6' lg='12' className='detail-option mb-4'>
												<h6 className='detail-option-heading'>
													Speed <span>(required)</span>
												</h6>
												<Select
													name='item_custitembicyclespeed'
													id='item_custitembicyclespeed'
													options={this.state.item_custitembicyclespeed}
													autosize={true}
													defaultValue={this.state.item_custitembicyclespeed[0]}
													className='react-select-container'
													classNamePrefix='react-select'
													styles={this.customSelectStyles}
													isSearchable={false}
													onChange={(e) => this.handleSelect(e)}
													value={this.state.bicycleSpeed}
												/>
											</Col>
										) : (
											""
										)}
										{this.state.item_custitembicycleaccessorysize.length > 0 ? (
											<Col sm='6' lg='12' className='detail-option mb-4'>
												<h6 className='detail-option-heading'>
													Size <span>(required)</span>
												</h6>
												<Select
													name='item_custitembicycleaccessorysize'
													id='item_custitembicycleaccessorysize'
													options={this.state.item_custitembicycleaccessorysize}
													autosize={true}
													defaultValue={
														this.state.item_custitembicycleaccessorysize[0]
													}
													className='react-select-container'
													classNamePrefix='react-select'
													styles={this.customSelectStyles}
													isSearchable={false}
													onChange={(e) => this.handleSelect(e)}
													value={this.state.accSize}
												/>
											</Col>
										) : (
											""
										)}
										{this.state.item_custitembicycleaccessorycolor.length >
											0 ? (
											<Col sm='6' lg='12' className='detail-option mb-4'>
												<h6 className='detail-option-heading'>
													Color <span>(required)</span>
												</h6>
												<Select
													name='item_custitembicycleaccessorycolor'
													id='item_custitembicycleaccessorycolor'
													options={
														this.state.item_custitembicycleaccessorycolor
													}
													autosize={true}
													defaultValue={
														this.state.item_custitembicycleaccessorycolor[0]
													}
													className='react-select-container'
													classNamePrefix='react-select'
													styles={this.customSelectStyles}
													isSearchable={false}
													onChange={(e) => this.handleSelect(e)}
													value={this.state.accColor}
												/>
											</Col>
										) : (
											""
										)}

										<Col sm='12' lg='12' className='detail-option mb-4'>
											<InputGroup className='w-100 mb-4'>
												<Input
													bsSize='lg'
													className='detail-quantity'
													name='quantity'
													type='number'
													min='1'
													onChange={this.handleChange}
													value={this.state.quantity}
													required
												/>
												<InputGroupAddon
													addonType='append'
													className='flex-grow-1'
												>
													<Button
														color='dark'
														block
														type='submit'
														disabled={!this.state.addToCartEnabled}
													>
														<i className='fa fa-shopping-cart mr-2'></i>
														{!this.state.isOutofStock ? "Add to Cart" : "Out of Stock"}
													</Button>
												</InputGroupAddon>
											</InputGroup>
										</Col>
									</Row>
								</Form>
							</Col>
						</Row>
					</ModalBody>
				</Modal>
			</React.Fragment>
		);
	}
}

export default ModalQuickView;
